var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive-router-view',{attrs:{"cache":_vm.$route.meta.keepAlive}}),_c('WxAuth',{ref:"wxAuthRef",on:{"success":_vm.wxAuthSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }